export const upsPopupSizeOptions = {popupHeight: 680, popupWidth: 500};
